var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-form__container" }, [
    _c("h1", { staticClass: "t-h1 title clr-white" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    !_vm.isSuccess
      ? _c(
          "form",
          {
            staticClass: "project-form__inner js-form js-static-form",
            attrs: { name: "project-form" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.formSubmit.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "project-form__row" },
              _vm._l(_vm.fields, function (item) {
                return _c(_vm.getComponentByType(item.component), {
                  key: item.id,
                  tag: "component",
                  attrs: { item: item },
                  model: {
                    value: _vm.updateField,
                    callback: function ($$v) {
                      _vm.updateField = $$v
                    },
                    expression: "updateField",
                  },
                })
              }),
              1
            ),
            _c("div", { staticClass: "project-form__row" }, [
              _vm._m(0),
              _c(
                "button",
                {
                  staticClass: "btn-submit btn bg-blue-18 clr-white",
                  class: { active: _vm.isSuccess },
                  attrs: { type: "submit", "data-text": "", submit: "" },
                },
                [_vm._v(_vm._s(_vm.sendText))]
              ),
            ]),
          ]
        )
      : _vm._e(),
    _vm.errors.length
      ? _c("div", { staticClass: "form-error" }, [_vm._v("Ошибка отправки")])
      : _vm._e(),
    _vm.isSuccess
      ? _c("div", {
          staticClass: "success-message clr-white",
          domProps: { innerHTML: _vm._s(_vm.successText) },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "project-form__checkbox" }, [
      _c("input", {
        attrs: {
          id: "project-form-agree",
          type: "checkbox",
          checked: "",
          name: "project-form-agree",
          value: "Y",
          required: "",
        },
      }),
      _c("label", { attrs: { for: "project-form-agree" } }, [
        _vm._v("Отправляя заявку, я подтверждаю, что ознакомлен и согласен с "),
        _c(
          "a",
          {
            attrs: { href: "/politika-konfidentsialnosti/", target: "_blank" },
          },
          [_vm._v("Политикой конфиденциальности")]
        ),
        _vm._v(" данного сайта"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }